// front/src/preview-mode/graph/entities.ts
import type { PreviewDestination, PreviewEventDef } from "./types";

export const EVENT_DEF_IDS = {
  page_view: "a8f7c2b1-1e60-4a3b-9f10-00001103c001",
  click: "a8f7c2b1-1e60-4a3b-9f10-00001103c002",
  form_started: "a8f7c2b1-1e60-4a3b-9f10-00001103c003",
  form_submitted: "a8f7c2b1-1e60-4a3b-9f10-00001103c004",
  appointment_booking_started: "a8f7c2b1-1e60-4a3b-9f10-00001103c005",
  appointment_booking_completed: "a8f7c2b1-1e60-4a3b-9f10-00001103c006",
  call_initiated: "a8f7c2b1-1e60-4a3b-9f10-00001103c007",
} as const;

export const EVENT_DEFS: PreviewEventDef[] = [
  {
    eventDefId: EVENT_DEF_IDS.page_view,
    name: "Page View",
    funnelStage: "",
    conversionSource: "",
    isRecommended: false,
    isOther: false,
    isHidden: false,
    description: "User viewed a page",
    totalEventsDelivered: 0,
    isHighVolumeEvent: true,
    adPlatformsDelivered: 0,
    adPlatformsDeliveredList: "",
    isSpecialCaseAdsDelivPv: true,
    hasNoRecentTraffic: false,
    tags: { "Auto Event": true },
    type: "",
  },
  {
    eventDefId: EVENT_DEF_IDS.click,
    name: "Click",
    funnelStage: "",
    conversionSource: "",
    isRecommended: false,
    isOther: true,
    isHidden: false,
    description: "User clicked an element",
    totalEventsDelivered: 0,
    isHighVolumeEvent: true,
    adPlatformsDelivered: 0,
    adPlatformsDeliveredList: "",
    isSpecialCaseAdsDelivPv: false,
    hasNoRecentTraffic: false,
    tags: { "Auto Event": true },
    type: "",
  },
  {
    eventDefId: EVENT_DEF_IDS.form_started,
    name: "Form Started",
    funnelStage: "MidFunnel",
    conversionSource: "user_configured",
    isRecommended: true,
    isOther: false,
    isHidden: false,
    description: "User focused a form field",
    totalEventsDelivered: 0,
    isHighVolumeEvent: false,
    adPlatformsDelivered: 3,
    adPlatformsDeliveredList: "",
    isSpecialCaseAdsDelivPv: false,
    hasNoRecentTraffic: false,
    tags: { "Custom Event": true },
    type: "",
  },
  {
    eventDefId: EVENT_DEF_IDS.form_submitted,
    name: "Form Submitted",
    funnelStage: "MidFunnel",
    conversionSource: "user_configured",
    isRecommended: true,
    isOther: false,
    isHidden: false,
    description: "User submitted a form",
    totalEventsDelivered: 0,
    isHighVolumeEvent: false,
    adPlatformsDelivered: 3,
    adPlatformsDeliveredList: "",
    isSpecialCaseAdsDelivPv: false,
    hasNoRecentTraffic: false,
    tags: { "Custom Event": true },
    type: "",
  },
  {
    eventDefId: EVENT_DEF_IDS.appointment_booking_started,
    name: "Appointment Booking Started",
    funnelStage: "MidFunnel",
    conversionSource: "user_configured",
    isRecommended: true,
    isOther: false,
    isHidden: false,
    description: "User entered the appointment booking flow",
    totalEventsDelivered: 0,
    isHighVolumeEvent: false,
    adPlatformsDelivered: 4,
    adPlatformsDeliveredList: "",
    isSpecialCaseAdsDelivPv: false,
    hasNoRecentTraffic: false,
    tags: { "Custom Event": true },
    type: "",
  },
  {
    eventDefId: EVENT_DEF_IDS.appointment_booking_completed,
    name: "Appointment Booking Completed",
    funnelStage: "BottomFunnel",
    conversionSource: "user_configured",
    isRecommended: true,
    isOther: false,
    isHidden: false,
    description: "User completed an appointment booking",
    totalEventsDelivered: 0,
    isHighVolumeEvent: false,
    adPlatformsDelivered: 5,
    adPlatformsDeliveredList: "",
    isSpecialCaseAdsDelivPv: false,
    hasNoRecentTraffic: false,
    tags: { "Custom Event": true, "Conversion Event": true },
    type: "",
  },
  {
    eventDefId: EVENT_DEF_IDS.call_initiated,
    name: "Call Initiated",
    funnelStage: "BottomFunnel",
    conversionSource: "user_configured",
    isRecommended: true,
    isOther: false,
    isHidden: false,
    description: "User clicked a phone number link",
    totalEventsDelivered: 0,
    isHighVolumeEvent: false,
    adPlatformsDelivered: 2,
    adPlatformsDeliveredList: "",
    isSpecialCaseAdsDelivPv: false,
    hasNoRecentTraffic: false,
    tags: { "Custom Event": true, "Conversion Event": true },
    type: "",
  },
];

export const DESTINATIONS: PreviewDestination[] = [
  {
    id: "dest-google-ads",
    platform: "google-ads",
    name: "Google Ads",
    isEnabled: true,
  },
  {
    id: "dest-meta-ads",
    platform: "facebook-pixel",
    name: "Meta Ads",
    isEnabled: true,
  },
  {
    id: "dest-bing-ads",
    platform: "bing-ads",
    name: "Microsoft Advertising",
    isEnabled: true,
  },
  {
    id: "dest-ga4",
    platform: "google-analytics-4",
    name: "Google Analytics 4",
    isEnabled: true,
  },
  {
    id: "dest-sfmc",
    platform: "salesforce",
    name: "Salesforce Marketing Cloud",
    isEnabled: true,
  },
];
